import React, { useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import TopAppBar from "../components/top-app-bar/TopAppBar";
import Sidebar from "../components/sidebar/Sidebar";
import SecondaryAppBar from "../components/secondary-app-bar/SecondaryAppBar";
import MainContent from "../components/main-content/MainContent";
import ChildrenProps from "../interfaces/common.interface";
import SnackbarNotifier from "../components/snackbar/Snackbar";

const Layout: React.FC<ChildrenProps> = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <>
      <SnackbarNotifier />
      <Box
        sx={{
          display: "grid",
          gridTemplateAreas: {
            xs: `"top-app-bar" "main-area"`,
            sm: `"top-app-bar top-app-bar" "sidebar main-area"`,
          },
          gridTemplateColumns: {
            xs: "1fr",
            sm: "auto 1fr",
          },
          gridTemplateRows: "40px 1fr",
          height: "100vh",
          width: "100vw",
        }}
      >
        {/* Top App Bar */}
        <Box
          sx={{
            gridArea: "top-app-bar",
            display: "flex",
            alignItems: "center",
            height: "40px",
            width: "100%",
          }}
        >
          <TopAppBar />
        </Box>

        {/* Sidebar */}
        {!isSmallScreen || drawerOpen ? (
          <Box
            sx={{
              gridArea: "sidebar",
              height: "100%",
              borderRight: "1px solid #ddd",
              zIndex: 1200,
            }}
          >
            <Sidebar drawerOpen={drawerOpen} />
          </Box>
        ) : null}

        {/* Main Area */}
        <Box
          sx={{
            gridArea: "main-area",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "hidden",
          }}
        >
          {/* Secondary App Bar - occupies height */}
          <Box sx={{ flexShrink: 0 }}>
            <SecondaryAppBar
              drawerOpen={drawerOpen}
              handleDrawerToggle={handleDrawerToggle}
            />
          </Box>

          {/* Main content - fills remaining space */}
          <Box
            sx={{
              flexGrow: 1,
              overflowY: "auto",
              mt: "80px",
            }}
          >
            <MainContent>{children}</MainContent>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Layout;
